<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>
<main class="container py-4">

  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h4 class="fw-bold mb-0">
        {{ isEditMode ? 'Edit Tier' : (isCopyMode ? 'Copy Tier' : 'New Tier') }}
      </h4>
      <div class="text-muted small">
        Configure compliance tier level, rank and defaults
      </div>
    </div>

    <button class="btn btn-outline-secondary btn-sm" (click)="cancel()">
      Back
    </button>
  </div>

  <div *ngIf="loading" class="text-center py-4">
    <div class="spinner-border"></div>
  </div>

  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>

  <div *ngIf="isCopyMode" class="alert alert-info">
    This form was prefilled from an existing tier. Update jurisdiction, customer type, or tier code before saving.
  </div>
  <form *ngIf="!loading" [formGroup]="form" (ngSubmit)="save()" class="card shadow-sm border-0">
    <div class="card-body">

      <div class="row g-3">
        <div class="col-md-4">
            <label class="form-label">Jurisdiction</label>
            <select class="form-select" formControlName="jurisdictionId">
                <option value="">Select jurisdiction</option>
                <option *ngFor="let item of jurisdictions" [value]="item.id">
                {{ item.code }} - {{ item.name }}
                </option>
            </select>

            <div class="small text-danger mt-1" *ngIf="jurisdictionId?.touched && jurisdictionId?.invalid">
                Jurisdiction is required.
            </div>
        </div>

        <div class="col-md-4">
          <label class="form-label">Customer Type</label>
          <select class="form-select" formControlName="customerType">
            <option value="">Select customer type</option>
            <option *ngFor="let item of customerTypes" [value]="item.value">{{ item.label }}</option>
          </select>

          <div class="small text-danger mt-1" *ngIf="customerType?.touched && customerType?.invalid">
            Customer type is required.
          </div>
        </div>

        <div class="col-md-4">
          <label class="form-label">Tier Code</label>
          <input class="form-control"
                 formControlName="tierCode"
                 placeholder="BASIC, ENHANCED" />

          <div class="small text-danger mt-1" *ngIf="tierCode?.touched && tierCode?.invalid">
            Tier code is required.
          </div>
        </div>

        <div class="col-md-4">
          <label class="form-label">Name</label>
          <input class="form-control"
                 formControlName="name"
                 placeholder="Basic Tier" />

          <div class="small text-danger mt-1" *ngIf="name?.touched && name?.invalid">
            Tier name is required.
          </div>
        </div>

        <div class="col-md-4">
          <label class="form-label">Rank</label>
          <input class="form-control"
                 type="number"
                 min="1"
                 formControlName="rank"
                 placeholder="1" />

          <div class="small text-danger mt-1" *ngIf="rank?.touched && rank?.invalid">
            Rank must be at least 1.
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label d-block">Default Tier</label>
          <div class="form-check form-switch mt-2">
            <input class="form-check-input" type="checkbox" formControlName="isDefault" />
            <label class="form-check-label">Yes</label>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label d-block">Active</label>
          <div class="form-check form-switch mt-2">
            <input class="form-check-input" type="checkbox" formControlName="isActive" />
            <label class="form-check-label">Enabled</label>
          </div>
        </div>
      </div>

      <div class="mt-4 d-flex gap-2">
        <button class="btn btn-primary" type="submit" [disabled]="saving">
          <span *ngIf="saving" class="spinner-border spinner-border-sm me-2"></span>
          {{ isEditMode ? 'Update Tier' : 'Create Tier' }}
        </button>

        <button class="btn btn-outline-secondary" type="button" (click)="cancel()">
          Cancel
        </button>
      </div>

    </div>
  </form>

  <app-footer></app-footer>
</main>
</div>
